// extracted by mini-css-extract-plugin
export var details = "_ey-0";
export var inspectorPopover = "_ey-1";